import {action, observable, computed} from 'mobx';
import Router from 'page';

class RouteStore {
  @observable _activeRoute = {
    pattern: null,
    params: null
  };
  _router = null;
  _routes = [];

  constructor(routes) {
    this._router = Router;
    this._routes = routes;

    this._routes.forEach(route => {
      this._router(route.pattern, ({params}) => this.setActive(route.pattern, params));
    });

    this.navigate(window.location.pathname);
  }

  @computed get activeRoute() {
    const route = this._routes.find(route => route.pattern === this._activeRoute.pattern);
    if (route) route.extra = this._activeRoute || {};
    return route;
  }

  navigate(route) {
    console.log('navigating to', route);
    this._router(route);
  }

  @action setActive = (pattern, params) => {
    this._activeRoute.pattern = pattern;
    this._activeRoute.params = params;
  }
}

export default RouteStore;



// WEBPACK FOOTER //
// ./src/store/RouteStore.js